import React from 'react';
import { ClipLoader } from 'react-spinners';
import cn from 'classnames';
import { primary } from '../constants/colors';

const Spinner = (props) => (
  <div className={cn(props?.className, 'sweet-loading')} id={props.id}>
    <ClipLoader className="clip-loader" size={60} loading color={primary} />
  </div>
);

export default Spinner;
